// Module
var code = "<span class=\"badge defaultcursor\" data-bind=\"text: useManualBenchmarkLevel() ? 'M' : 'A', event: {mouseover: showBenchmarkLevelToopltip, mouseout: closeToopltip}\"></span>";
// Exports
module.exports = code;